<template>
<div class="home">
    <ol class="breadcrumbs">
        <router-link to="/dashboard">Dashboard</router-link> > Inward Goods
    </ol>
    <div class="d-sm-flex align-items-top justify-content-start mb-4">
        <h1 class="h3 mb-0 text-gray-800">Inward Goods</h1>

    </div>
    <div class="card shadow mb-4">
        <div id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4 card-body">
            <div class="dataTables_length table-filters" id="dataTable_length">
                <div>
                <label>
                    <span class="p-2">Branch:</span>
                    <select v-model="filters.branch" name="dataTable_length" aria-controls="dataTable" class="custom-select form-control form-control-sm">
                        <option :value="null">All</option>
                        <option :value="1">Auckland</option>
                        <option :value="0">Wellington</option>{{filters.branch}}
                    </select>
                </label>

                <label class="ml-3 mr-auto" for="picker" v-bind:class="{selectedFilter: dateRange.startDate !== null && dateRange.endDate !== null}">Date Range:
                                    <date-range-picker ref="picker" opens="center" :maxDate="maxDate" v-model="dateRange">
                                        <template v-slot:input="picker" style="min-width: 350px;">
                                            {{ picker.startDate | date  }} - {{ picker.endDate | date  }}
                                        </template>
                                    </date-range-picker>
                  </label>
                <button v-if="dateRange.startDate !== null || dateRange.endDate !== null" @click="clearDateRange()" class="ml-1 btn btn-sm btn btn-outline-secondary">Clear</button>
                </div>
                <button @click="downloadCSV" class="btn btn-sm mb-1 btn-info"><i class="fas fa-fw fa-file-excel"></i> Download CSV</button>
            </div>
            <div class="table-responsive-xl">
                <div>
                   <table class="fixed fixed-lg selectable">
                        <thead>
                            <tr>
                                <th class="col-date">Added</th>

                                <!--<<th>Collection</th>-->
                                <th class="col-job">Job#</th>
                                <th class="col-date">Branch</th>
                                <th>From</th>
                                <th class="col-address">Site/Location</th>
                                <th class="col-date">Carrier/Consignment</th>
                                <!--<<th>Alt Phone</th>-->
                                <th>Entered by</th>
                                <th class="col-sm">#Items</th>
                                <th class="col-sm">Weight</th> 
                                <td class="col-sm" v-if="user && user.data && user.data.role > 8"></td>

                                <!--<th>Accounts</th><th>Return</th><th>Attachment</th><th>Items</th>
          <th></th>-->
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="rw" v-for="(inward, index) in inwards" v-bind:key="index">
                                <td class="col-date" :time="inward.submitted">{{inward.submitted | longDate}}</td>
                                <!--<td>{{job.collection}}</td>-->
                                <td class="col-job" v-if="!inward.miscDrop">{{inward.jobid | jobid}}</td>
                                <td class="col-job" v-if="inward.miscDrop && !inward.isTransfer">Misc. Drop</td>
                                <td class="col-job" v-if="inward.miscDrop && inward.isTransfer">Transfer</td>
                                <td class="col-date">{{inward.branch | branchFilter}}</td>
                                <td title="company">{{inward.from}}{{inward.company}}</td>

                                <td class="col-address">{{inward.site}}{{inward.address}}</td>

                                <td class="col-date">{{inward.carrier}}</td>
                                <!--<td>{{job.altphone}}</td>-->
                                <td>{{inward.enteredby}}</td>
                                <td class="col-sm">{{inward.numItems}}</td>
                                <td class="col-sm">{{inward.weight}}kg</td>
                                <td class="col-sm" v-if="user && user.data && user.data.role > 8"><button style="margin-top:-0.5rem;margin-bottom:-0.25rem;" class="btn btn-sm" @click="deleteEntry(index, inward)"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                <!--<td>
            <div class="nav-item dropdown hover-dropdown">
              <button class="btn p-2 nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></button>
              <div class="dropdown-menu dropdown-menu-right animated--fade-in" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="#">Action</a>
                <a class="dropdown-item" href="#">Another action</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#">Something else here</a>
              </div>
            </div>
          </td>-->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
                                    <div v-if="inwards.length >= limit" class="d-flex justify-content-center paging_simple_numbers" id="dataTable_paginate">
                            <button class="btn btn-outline-primary btn-center" @click="loadMore()">Load More</button>
                        </div>
        </div>
        


    </div>
</div>
</template>

<script>
//import Modal from '../components/Modal.vue'
// Get a RTDB instance

import {
    db
} from "../main";

import {
    mapGetters
} from "vuex";

import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


const inwardsDB = db.ref("inwardGoods");

export default {
    name: "InwardsGoods",
    components: {
        DateRangePicker
    },
    data() {
        return {
            inwardsRaw: [],
            opened: [],
            limit: 40,
            filters: {
                branch: null
            },
            maxDate: new Date(),
            dateRange: {
                startDate: null,
                endDate: null
            },
        };
    },
    filters: {
        date(date) {
            if (date) {
                return new Intl.DateTimeFormat("en-NZ").format(date);
            } else {
                return "Any Date"
            }
        }
    },
    computed: {
        ...mapGetters({
            orgs: "orgs",
            user: "user"
        }),
        inwards: function () {
            return [...this.inwardsRaw].reverse();
        },
        combinedWatch() {
            return this.filters.branch + this.limit + this.dateRange.startDate + this.dateRange.endDate; 
        },
    },
    methods: {
        deleteEntry(i, entry) {
            console.log('i', i);
            const t = this;
            t.$confirm(
                    {
                    message: `Are you sure you want to DELETE Inward Entry from ${entry.from || ''}${entry.company || ''}?`,
                    button: {
                        no: 'Cancel',
                        yes: 'Delete'
                    },
                    /**
                     * Callback Function
                     * @param {Boolean} confirm 
                     */
                    callback: confirm => {
                        if (confirm) {
    
                            db.ref('inwardGoods/' + t.inwards[i]['.key']).remove();
                        }
                        }
                    }
            )
        },
        und(val){
            if(!val || val === 'undefined'){
                return '';
            }else{
                return String(val).replace(/"/g, '""');
            }
        },
        downloadCSV() {
            var t = this;
            let csvContent = "data:text/csv;charset=utf-8,";

            csvContent += 'Date, Job or Type, Company, Name, Location, Entered By, No. of Items,Weight' + '\r\n';
            this.inwards.forEach(function (rw) {
                console.log(rw);
                let row = '"' + t.$moment(rw['submitted']).format("DD/MM/YY h:mma") + '",';
                if(rw['miscDrop'] && !rw['isTransfer']){
                    row += '"Misc Drop",';
                }else if(rw['miscDrop'] && rw['isTransfer']){
                    row += '"Transfer",';
                }else if(rw['jobid']){
                    row += '"' + t.$options.filters.jobid(rw['jobid']) + '",';
                }
                row += '"' + t.und(rw['company']) + '",';
                row += '"' + t.und(rw['name']) + '",';
                row += '"' + t.und(rw['address']) + '",';
                row += '"' + t.und(rw['enteredby']) + '",';
                row += '"' + t.und(rw['numItems']) + '",';
                row += '"' + t.und(rw['weight']) + '",';
                csvContent += row + '\r\n';
            });

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            
            var branch = this.$options.filters.branchFilter(t.filters.branch);

            link.setAttribute("download", "inward-goods-" + this.$moment(Date.now()).format("DDMMMYYYY") + branch + ".csv");
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        toggle(id) {
            const index = this.opened.indexOf(id);
            if (index > -1) {
                this.opened.splice(index, 1);
            } else {
                this.opened.push(id);
            }
        },
        loadMore() {
            this.limit += 100;
        },
        clearDateRange(){
            this.dateRange = {
                startDate: null,
                endDate: null
            }
            this.limit = 40;
        },
    },
    watch: {
        combinedWatch: {
            // call it upon creation too
            immediate: true,
            handler() {
                const t = this;
                console.log(t.filters.branch)
                if (this.dateRange.startDate !== null && this.dateRange.endDate !== null) {
                    this.limit = 10000;
                    this.$rtdbBind(
                        "inwardsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        inwardsDB.orderByChild("submitted").startAt(this.dateRange.startDate.toISOString()).endAt(this.dateRange.endDate.toISOString()).limitToLast(this.limit)
                    );
                }else if (t.filters.branch !== null) {

                    this.$rtdbBind(
                        "inwardsRaw",
                        inwardsDB.orderByChild("branch").equalTo(t.filters.branch).limitToLast(t.limit)
                    );
                } else {
                    this.$rtdbBind(
                        "inwardsRaw",
                        inwardsDB.orderByChild("submitted").limitToLast(t.limit)
                    );
                }
            },
        },
    },
};
</script>
<style>
label.selectedFilter {
    font-weight: bold !important;

}

.selectedFilter .form-control {
    font-weight: bold !important;
}
</style>